import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ImageGallery = () => {
  const images = [
    {
      src: "/gallery/DSC_0136.jpg",
      alt: "Fiesta del Tendero 2024 - Evento"
    },
    {
      src: "/gallery/DSC_0209.jpg",
      alt: "Fiesta del Tendero 2024 - Participantes"
    },
    {
      src: "/gallery/DSC_0269.jpg",
      alt: "Fiesta del Tendero 2024 - Actividades"
    },
    {
      src: "/gallery/DSC_0340.jpg",
      alt: "Fiesta del Tendero 2024 - Comercio"
    },
    {
      src: "/gallery/DSC_0408.jpg",
      alt: "Fiesta del Tendero 2024 - Celebración"
    },
    {
      src: "/gallery/DSC_8909.jpg",
      alt: "Fiesta del Tendero 2024 - Comunidad"
    },
    {
      src: "/gallery/DSC_8914.jpg",
      alt: "Fiesta del Tendero 2024 - Integración"
    },
    {
      src: "/gallery/DSC_8930.jpg",
      alt: "Fiesta del Tendero 2024 - Networking"
    },
    {
      src: "/gallery/DSC_8933.jpg",
      alt: "Fiesta del Tendero 2024 - Empresarios"
    },
    {
      src: "/gallery/DSC_8945.jpg",
      alt: "Fiesta del Tendero 2024 - Magangué"
    },
    {
      src: "/gallery/DSC_8979.jpg",
      alt: "Fiesta del Tendero 2024 - Competencia"
    },
    {
      src: "/gallery/DSC_8995.jpg",
      alt: "Fiesta del Tendero 2024 - Torneo"
    },
    {
      src: "/gallery/DSC_9025.jpg",
      alt: "Fiesta del Tendero 2024 - Equipos"
    },
    {
      src: "/gallery/DSC_9041.jpg",
      alt: "Fiesta del Tendero 2024 - Deporte"
    },
    {
      src: "/gallery/DSC_9051.jpg",
      alt: "Fiesta del Tendero 2024 - Jugadores"
    },
    {
      src: "/gallery/DSC_9052.jpg",
      alt: "Fiesta del Tendero 2024 - Acción"
    },
    {
      src: "/gallery/DSC_9054.jpg",
      alt: "Fiesta del Tendero 2024 - Diversión"
    },
    {
      src: "/gallery/DSC_9056.jpg",
      alt: "Fiesta del Tendero 2024 - Emoción"
    },
    {
      src: "/gallery/DSC_9073.jpg",
      alt: "Fiesta del Tendero 2024 - Victoria"
    },
    {
      src: "/gallery/DSC_9106.jpg",
      alt: "Fiesta del Tendero 2024 - Premiación"
    },
    {
      src: "/gallery/DSC_9118.jpg",
      alt: "Fiesta del Tendero 2024 - Ganadores"
    },
    {
      src: "/gallery/DSC_9159.jpg",
      alt: "Fiesta del Tendero 2024 - Trofeos"
    },
    {
      src: "/gallery/DSC_9178.jpg",
      alt: "Fiesta del Tendero 2024 - Reconocimientos"
    },
    {
      src: "/gallery/DSC_9179.jpg",
      alt: "Fiesta del Tendero 2024 - Campeones"
    },
    {
      src: "/gallery/DSC_9200.jpg",
      alt: "Fiesta del Tendero 2024 - Clausura"
    },
    {
      src: "/gallery/DSC_9201.jpg",
      alt: "Fiesta del Tendero 2024 - Final"
    },
    {
      src: "/gallery/DSC_9202.jpg",
      alt: "Fiesta del Tendero 2024 - Despedida"
    },
    {
      src: "/gallery/DSC_9205.jpg",
      alt: "Fiesta del Tendero 2024 - Recuerdos"
    },
    {
      src: "/gallery/20240922_175439.jpg",
      alt: "Fiesta del Tendero 2024 - Organización"
    },
    {
      src: "/gallery/20240922_175458.jpg",
      alt: "Fiesta del Tendero 2024 - Logística"
    }
  ];

  return (
    <section id="galeria" className="gallery-section">
      <div className="container">
        <h2 className="section-title">Así vivimos nuestra fiesta en el 2024</h2>
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            }
          }}
          className="gallery-swiper"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="gallery-item">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ImageGallery;